<div fxLayout fxLayoutAlign="start center">
  <strong fxFlex>{{ label }}</strong>
  <sbnb-property-update-status
    [edited]="edited"
    [hasAirbnbListing]="hasAirbnbListing"></sbnb-property-update-status>
</div>
<div fxLayout fxLayoutAlign="start center" class="detail-subheader">
  <div fxLayoutGap="8px" fxLayoutAlign="start center">
    <button class="increment-button" (click)="decrement()">-</button>
    <input
      class="increment-field"
      type="number"
      #numInput
      min="0"
      max="99"
      [step]="allowDecimals ? 'any' : '1'"
      [value]="value"
      appearance="none"
      (input)="handleInput(numInput)"
      (change)="handleChange(numInput.value)" />
    <button class="increment-button" (click)="value = value + 1; updated.emit(value)">+</button>
  </div>
</div>
